import { ValueObject, Validation, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class InstrumentDetailsReportCriteria extends ValueObject {
    public instrumentTypeName: string | null = null;

    public instrumentSubType: string | null = null;

    public instrumentTypeId: string | null = null;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}